module.exports = __webpack_public_path__ + "img/logo-nl.5ac92a65.svg";